import { render, staticRenderFns } from "./IconSvgMegaphone.vue?vue&type=template&id=374de8c0&scoped=true&"
import script from "./IconSvgMegaphone.vue?vue&type=script&lang=js&"
export * from "./IconSvgMegaphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374de8c0",
  null
  
)

export default component.exports